// extracted by mini-css-extract-plugin
export default {"wrapper":"VipCustomerList_wrapper__RM12P","action-button":"VipCustomerList_action-button__PO46O"};